<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
import {yesNoRepresentation} from "@/helpers/transformers";
export default {
  name: "TiposFreteTransportadora",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-frete-transportadora",
      columns: [
        {
          label: "ID",
          field: "id",
          sortable: false
        },
        {
          label: "Tipo de Frete",
          field: "tipo_frete",
          sortable: false,
          representedAs : (row) => !!(row?.cobranca)
              ? `${row.tipofrete_id} - ${row.tipofrete.descricao}`
              : row.tipofrete_id
        },
        {
          label: "Transportadora",
          field: "transportadora",
          sortable: false,
          representedAs : (row) => !!(row?.transportadora)
              ? `${row.transportadora_id} - ${row.transportadora.razaosocial}`
              : row.transportadora_id
        },
        {
          label: "Ativo",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo)
        }
      ],
    };
  },
};
</script>
